import type { Theme } from '@mui/material';

export const styles = {
  tableCell: (theme: Theme) => ({
    maxWidth: '200px',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
    height: '48px',
    padding: '8px 16px',
    color: theme.colors.neutral[500],
    fontWeight: 500,
  }),
};
